import { render, staticRenderFns } from "./ApprovalRemarks.vue?vue&type=template&id=1a33773e"
import script from "./ApprovalRemarks.vue?vue&type=script&lang=js"
export * from "./ApprovalRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports